import React, { Component } from 'react';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Disclaimer from '../Disclaimer';
import { withTranslation, Trans } from 'react-i18next';
import { view09ImageOptions } from './views/view09'

class BathingPlatform extends Component {
    constructor(props) {
        super(props);
        this.handleBathingPlatformChange = this.handleBathingPlatformChange.bind(this);
        this.handleTeakOnBathingPlatformChange = this.handleTeakOnBathingPlatformChange.bind(this);
      
    }

    handleBathingPlatformChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BathingPlatform = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTeakOnBathingPlatformChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnBathingPlatform = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }


    render() {
        let imageOptions = view09ImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Bathing platform' /></h1>

                    <p><Trans defaults='The X4<sup>3</sup> features an optional bathing platform which is operated electrically, integrated attachment for hang-on bathing ladder with {{wood}} steps.' values={{ wood: (this.props.configuration.Deck.value === 1) ? 'Genuine  teak' : 'flexiteek' }} /></p>

                    <RadioGroup label={this.props.t("Bathing platform:")} options={this.props.bathingPlatformOptions} value={this.props.configuration.BathingPlatform} onChange={this.handleBathingPlatformChange} />

                    <Disclaimer />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(BathingPlatform);


// WEBPACK FOOTER //
// ./src/X43MK2/BathingPlatform.js